module.exports = __webpack_public_path__ + "img/HeySong_Car_step03_3.345f6fd5.png";